import type { TFunction } from 'i18next';
import type { EmailIntegrationErrorCode } from '@clareefai/types';

interface MaybeRtkError {
  data?: { code?: string; message?: string };
  status?: number;
}

const KNOWN_CODES: ReadonlyArray<EmailIntegrationErrorCode> = [
  'SMTP_HOST_UNRESOLVED',
  'SMTP_CONNECTION_REFUSED',
  'SMTP_TIMEOUT',
  'SMTP_TLS_MISMATCH',
  'SMTP_AUTH_FAILED',
  'SMTP_FROM_NOT_ALLOWED',
  'SMTP_INVALID_RECIPIENT',
  'SMTP_GENERIC_FAILURE',
  'INTEGRATION_NOT_FOUND',
  'INTEGRATION_NOT_VERIFIED',
  'INTEGRATION_DECRYPT_FAILED',
  'OAUTH_TOKEN_REFRESH_FAILED',
];

/**
 * Pull a typed error code out of an RTK Query error and translate it via the
 * `settings.emailSender.errors.*` namespace. Falls back to the server-supplied
 * message, then to a generic localized string.
 */
export function smtpErrorMessage(error: unknown, t: TFunction): string {
  const err = error as MaybeRtkError | undefined;
  const code = err?.data?.code;
  if (code && KNOWN_CODES.includes(code as EmailIntegrationErrorCode)) {
    return t(`settings.emailSender.errors.${code}`);
  }
  const serverMessage = err?.data?.message;
  if (serverMessage) return serverMessage;
  return t('settings.emailSender.errors.GENERIC');
}
